import { ICredit } from "../../../services/api/credits-service";

class CreditSrore {
    private _model?: ICredit;

    public get id(): number | undefined {
        return this._model?.id;
    }

    public get store_customer_id(): number | undefined {
        return this._model?.store_customer_id;
    }

    public get credits_formatted(): string {
        return this._model?.credits_formatted ?? '';
    }

    public get gift_card_credits_formatted(): string {
        return this._model?.gift_card_credits_formatted ?? '';
    }

    public get discount_code(): string {
        return this._model?.discount_code ?? '';
    }

    public get admin_customer_url(): string {
        return this._model?.admin_customer_url ?? '';
    }

    public get admin_discounts_url(): string {
        return this._model?.admin_discounts_url ?? '';
    }

    public setModel(model: ICredit) {
        this._model = { ...model };
    }

    public getModel(): ICredit | undefined {
        const model = this._model ? { ...this._model } : undefined;
        return model;
    }
}

export default CreditSrore;